import React, { PureComponent } from 'react'
import { loadSwagger } from '../../services/swagger-ui'
import { getApi } from '../../services/api-catalog'
import Head from '../../components/Head'

export default class ApiDetailsPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}

    getApi(props.match.params.apiId)
    .then(api => {
      this.setState({
        api
      })
      loadSwagger(api.swagger)
    })
  }

  render() {
    return (<div>
      <Head {...this.props} />
      <div className="containerWrapper">
        <div className="containerWrapper" style={{backgroundColor:"white"}}>
          <section className="swagger-section">
            <div className="swagger-ui-wrap" id="swagger-ui-container" style={{padding:"0px !important"}}></div>
          </section>
        </div>
      </div>
    </div>)
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/ApiDetails/index.js
 **/